import { useEffect } from "react";
import { sha256 } from "../components/atoms/DependencyHelper";
import {
  getCookieValue
} from "../utils/helperServices";

import {
  Logger,
} from "../utils/logger";

export const utagDev =
  "https://tags.tiqcdn.com/utag/vodafone/za-microservice/dev/utag.js";
export const utagUat =
  "https://tags.tiqcdn.com/utag/vodafone/za-microservice/dev/utag.js";
export const utagQa =
  "https://tags.tiqcdn.com/utag/vodafone/za-microservice/qa/utag.js";
export const utagProd =
  "https://tags.tiqcdn.com/utag/vodafone/za-microservice/prod/utag.js";

  export const utagSyncDev =
  "https://tags.tiqcdn.com/utag/vodafone/za-microservice/dev/utag.sync.js";
export const utagSyncUat =
  "https://tags.tiqcdn.com/utag/vodafone/za-microservice/dev/utag.sync.js";
export const utagSyncQa =
  "https://tags.tiqcdn.com/utag/vodafone/za-microservice/qa/utag.sync.js";
export const utagSyncProd =
  "https://tags.tiqcdn.com/utag/vodafone/za-microservice/prod/utag.sync.js";

function lower(obj) {

  for (var prop in obj) {

    if (prop === 'link_obj') {
      obj.link_obj = undefined;

      continue;
    }

    if (typeof obj[prop] === 'string') {
      obj[prop] = obj[prop].toLowerCase();
    }

    if (typeof obj[prop] === 'object') {
      lower(obj[prop]);
    }
  }

  return obj;
}

export const loadUtag = (env) => {
  let url = "";
  switch (env) {
    case "prod":
    case "stg":
      url = utagProd;
      break;
    case "qa":
      url = utagQa;
      break;
    default:
      url = utagDev;
  }
  (function (a, b, c, d) {
    a = url; // URL for utag.js
    b = document;
    c = "script";
    d = b.createElement(c);
    d.src = a;
    d.type = "text/java" + c;
    d.async = true;
    a = b.getElementsByTagName(c)[0];
    a.parentNode.insertBefore(d, a);
  })();
};

export const utagQue = () => {
    var queue = [];
    var initialized = false;
    var frequency = 100;
    var timeout = 200 * frequency; // 2 seconds`

    function process() {
      if (!initialized) {
        return;
      }

      var action = null;

      while ((action = queue.shift())) action();
    }

    function view(data) {
      queue.push(function () {
        window.utag.view(data);
      });

      process();
    }

    function link(data) {
      queue.push(function () {
        window.utag.link(data);
      });

      process();
    }

    window.MyTIQ = {
      view: view,
      link: link,
    };

    (function run() {
      window.setTimeout(function () {
        if ("utag" in window) {
          initialized = true;
          timeout = 0;

          process();
        }

        timeout -= frequency;

        if (timeout > 0) {
          run();
        }
      }, frequency);
    })();
}

export const setPageMetaData = () => {
  //  TO DO: Ask Eugene for these values
  window.pageMetaData = {
    categoryLevel: 0,
    currentDesktop: "kubernetes",
    pageName: "my application",
    pageURL: "my application",
    portalPath: "vodacom",
    weblogicPageName: "myvodacom:my application",
    autoTagging: false,
  };

  window.tealiumAuthData = {}; // default empty data object
  window.utag_data = {};
};

export const setAutoTagging = (setValue) => {
  if(window.pageMetaData){
    window.pageMetaData.autoTagging = setValue;
  } else{
    setPageMetaData();
    window.pageMetaData.autoTagging = setValue;
  }
}

export const setCustomEventArray = () => {
  window.CustomEventArray = function (callback) {
    window.CustomEventArray.EVENT_TYPE = {
      PUSH: "push",
      POP: "pop",
    };
    var cb = callback || function () {};
    var _stack = [];
    var cb_queue = [cb];
    var processCallbacks = function (evt, obj) {
      for (var i = 0, len = cb_queue.length; i < len; i++) {
        cb_queue[i](evt, obj);
      }
    };
    this.push = function (obj) {
      _stack.push(obj);
      processCallbacks(window.CustomEventArray.EVENT_TYPE.PUSH, obj);
    };
    this.pop = function () {
      var o = _stack.pop();
      processCallbacks(window.CustomEventArray.EVENT_TYPE.POP, o);
      return o;
    };
    this.stack = function () {
      return _stack;
    };
    this.setCallback = function (callback) {
      cb_queue.push(callback);
    };
  };

  window.VodacomJSErrorEvents = new window.CustomEventArray();
  window.onerror = function (msg, url, line, col, error) {
    var d = {};
    d.msg = msg;
    d.url = url;
    d.line = line;
    d.col = !col ? "" : col;
    d.err = !error ? "" : error;
    window.VodacomJSErrorEvents.push(d);
  };
};

export const view = (data) => {
  if(getCookieValue("miniApp") === 'true'){
    data.header_type = "mini_app"
  }
  const lowerData = lower(data);
  try {

    if (data && (data.page_errors || data.page_errors_code)) {

      Logger.error(
        new Error(data.page_errors || "An unknown utag error occurred"),
        null,
        { AnalyticsData: lowerData },
        { utag_code: data.page_errors_code || "unknown" }
      );
    }

    window.MyTIQ.view(lowerData);
    //Added for unit testing purpose need to remove at the time of prod
    // console.log("view executed with", lowerData);
  } catch (error) {

    console.log("window.utag.view error");

    Logger.error(
      error,
      null,
      {
        AnalyticsData: {
          ...lowerData,
        }
      },
      { utag_code: data.page_errors_code || "unknown" }
    );
  }
};

export const link = (data) => {
  const lowerData = lower(data);
  try{
    if (data && (data.page_errors || data.page_errors_code)) {

      Logger.error(
        new Error(data.page_errors || "An unknown utag error occurred"),
        null,
        { AnalyticsData: lowerData },
        { utag_code: data.page_errors_code || "unknown" }
      );
    }
    window.MyTIQ.link(lowerData);
    //Added for unit testing purpose need to remove at the time of prod
    // console.log("utag link executed with", lowerData);
  } catch(error){

    console.warn("window.utag.link error");

    Logger.error(
      error,
      null,
      {
        AnalyticsData: {
          ...lowerData,
        }
      },
      { utag_code: data.page_errors_code || "unknown" }
    );
  }
};

export const getUtagData = (attributes=[]) => {
  if (typeof utag_data !== "undefined"){
    if(attributes.length){
      let retrievedData = {};
      attributes.forEach(key => {
        retrievedData[key] = utag_data[key];
      });
      return retrievedData;
    }
    const tempObject = {...utag_data};
    delete tempObject.page_event;
    return tempObject;
  }
  return {}
};

export const error = (msg) => {
  const analyticsData = {
    page_form_event: "error",
    page_errors: msg,
  }
  if (utag_data){
    analyticsData.page_name = utag_data.page_name;
  }
  link(analyticsData);
}
export const getProfileData = (loggedIn, profileData) => {
  try{
    let userData = {}
    if(loggedIn){
      userData.visitor_login_status = "logged in";
      if(profileData){
        if(profileData.customerId){
          userData.visitor_id_hash = profileData.customerId;
        }
      }
      if(profileData){
        if(profileData.telephone){
          userData.visitor_msisdn_hash = sha256(profileData.telephone);
          userData.visitor_customer_id = sha256(profileData.telephone);
        }
      }
      userData.visitor_subscription_type = "";
      return userData;
    }
    return {visitor_login_status:"logged out", visitor_msisdn_hash: "", visitor_customer_id: "", visitor_id_hash: "", visitor_subscription_type: "" }
  }
  catch (e){
    console.log(e);
  }
};

export const setPageName = (pageName) => {
  if (utag_data){
    utag_data.page_name = pageName;
  }
}

export const getPageName = () => {
  if (utag_data){
    return utag_data.page_name;
  }
  return "";
}

export const setCookieQue = () => {
  var queue = [];
  var initialized = false;
  var frequency = 100;
  var timeout = 400 * frequency; // 2 seconds`

  function process() {
    if (!initialized) {
      return;
    }

    var action = null;

    while ((action = queue.shift())) action();
  }

  function allowAll() {
    if(!queue.length){
      queue.push(function () {
        window.OneTrust.AllowAll();
      });
    }
    process();
  }

  window.MyQue = {
  allowAll: allowAll,
  };

  (function run() {
    window.setTimeout(function () {
      if ("OneTrust" in window) {
        initialized = true;
        timeout = 0;

        process();
      }

      timeout -= frequency;

      if (timeout > 0) {
        run();
      }
    }, frequency);
  })();
}

export const AnalyticsWrapper = () => {
  useEffect(() => {
    utagQue();
    setPageMetaData();
    setCustomEventArray();
    setCookieQue();
  }, []);
  return <></>
};
